import { generatePath } from '@cibo/core'
import AddIcon from '@mui/icons-material/Add'
import { Box, Button, Container, Grid, Paper, Stack, Typography, useTheme } from '@mui/material'
import { BaselineInfo } from 'features/Inventories/components/BaselineInfo'
import { BaselinePeriod } from 'features/Inventories/components/BaselinePeriod'
import { BoundariesList } from 'features/Inventories/components/BoundariesList'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { SCOPE_THREE_ROUTES } from '../../../navigation/types/scopeThreeRoutes'
import { BoundariesMap } from './BoundariesMap'

export const BoundaryTab = () => {
  const { inventoryId } = useParams()
  const { t } = useTranslation('@cibo/Inventories/BaselinePeriod')
  const { palette } = useTheme()

  const navigate = useNavigate()

  const offtakeRoute = generatePath(`${SCOPE_THREE_ROUTES.DETAIL}/offtake`, { inventoryId })

  if (!inventoryId) return null

  return (
    <Container>
      <Grid container columns={2} spacing={2} sx={{ marginBottom: 4 }}>
        <Grid item xs={2}>
          <Paper
            sx={{
              borderRadius: '12px',
              overflow: 'hidden',
              position: 'relative',
              height: 400,
              width: '100%',
            }}
          >
            <Stack direction="row">
              <Stack padding={3}>
                <Typography variant="h6" sx={{ marginBottom: 1 }} data-testid="boundaryListTitle">
                  {t('boundaryListTitle')}
                </Typography>
                <Typography variant="subtitle2" color="text.secondary" sx={{ width: '100%' }}>
                  {t('boundaryListDescription')}
                </Typography>

                <BoundariesList inventoryId={inventoryId} />
              </Stack>

              <Box sx={{ width: '100%', height: 400, position: 'relative' }}>
                <BoundariesMap inventoryId={inventoryId} />
              </Box>
            </Stack>
          </Paper>
        </Grid>

        <Grid item xs={1}>
          <BaselineInfo inventoryId={inventoryId} />
        </Grid>

        <Grid item xs={1}>
          <BaselinePeriod inventoryId={inventoryId} />
        </Grid>

        <Grid item xs={2}>
          <Paper
            sx={{
              borderRadius: '12px',
              overflow: 'hidden',
              position: 'relative',
              width: '100%',
              padding: 3,
            }}
          >
            <Typography variant="h6" sx={{ marginBottom: 2 }}>
              {t('historicalOfftake')}
            </Typography>

            <Stack
              component="section"
              spacing={2}
              alignItems="center"
              sx={{
                p: 2,
                backgroundColor: 'background.default',
                backgroundImage: `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='12' ry='12' stroke='${palette.divider}' stroke-width='1.5' stroke-dasharray='4%2c 4' stroke-dashoffset='4' stroke-linecap='square'/%3e%3c/svg%3e")`,
                borderRadius: '12px',
              }}
            >
              <Typography>{t('historicalOfftakeCTA')}</Typography>

              <Button
                variant="outlined"
                color="secondary"
                startIcon={<AddIcon />}
                onClick={() => navigate(offtakeRoute)}
              >
                {t('inputDataButton')}
              </Button>
            </Stack>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  )
}
